import axios from "axios";
export async function getTests(colel_id, date) {
  return await axios.get(`/test/all/${colel_id}/${date.getMonth() + 1}/${date.getFullYear()}`);
}

export async function postTest(test, colel_id, date) {
  return await axios.post(`/test/`, test);
}
